import { useEffect, useRef } from 'react';

export function useIsMounted() {
  const componentIsMounted = useRef(false);
  useEffect(() => {
    componentIsMounted.current = true;
    return () => {
      componentIsMounted.current = false;
    };
  }, []);

  return componentIsMounted;
}

export default useIsMounted;
